/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { DeliveryType } from 'app/shared/model/enumerations/delivery-type.model';
import { PregnancyResult } from 'app/shared/model/enumerations/pregnancy-result.model';
import { createEntity, getEntity, reset, updateEntity } from './obstetric-event.reducer';

export const ObstetricEventUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const obstetricEventEntity = useAppSelector(state => state.obstetricEvent.entity);
  const loading = useAppSelector(state => state.obstetricEvent.loading);
  const updating = useAppSelector(state => state.obstetricEvent.updating);
  const updateSuccess = useAppSelector(state => state.obstetricEvent.updateSuccess);
  const genderValues = Object.keys(Gender);
  const deliveryTypeValues = Object.keys(DeliveryType);
  const pregnancyResultValues = Object.keys(PregnancyResult);

  const handleClose = () => {
    navigate(`/obstetric-event${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getPregnancyCases({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.pregnancyConfirmedDate !== undefined && typeof values.pregnancyConfirmedDate !== 'number') {
      values.pregnancyConfirmedDate = Number(values.pregnancyConfirmedDate);
    }
    if (values.lengthOfPregnancy !== undefined && typeof values.lengthOfPregnancy !== 'number') {
      values.lengthOfPregnancy = Number(values.lengthOfPregnancy);
    }
    if (values.childWeight !== undefined && typeof values.childWeight !== 'number') {
      values.childWeight = Number(values.childWeight);
    }
    if (values.labourStartDate !== undefined && typeof values.labourStartDate !== 'number') {
      values.labourStartDate = Number(values.labourStartDate);
    }
    if (values.lenghtOfLabor !== undefined && typeof values.lenghtOfLabor !== 'number') {
      values.lenghtOfLabor = Number(values.lenghtOfLabor);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...obstetricEventEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          childGender: 'MALE',
          deliveryType: 'NORMAL',
          eventType: 'ABORTION',
          ...obstetricEventEntity,
          patient: obstetricEventEntity?.patient?.id,
          pregnancy: obstetricEventEntity?.pregnancy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.obstetricEvent.home.createOrEditLabel" data-cy="ObstetricEventCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.obstetricEvent.home.createOrEditLabel">Create or edit a ObstetricEvent</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="obstetric-event-id"
                  label={translate('tinyMedicRestApp.obstetricEvent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.pregnancyConfirmedDate')}
                id="obstetric-event-pregnancyConfirmedDate"
                name="pregnancyConfirmedDate"
                data-cy="pregnancyConfirmedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.lengthOfPregnancy')}
                id="obstetric-event-lengthOfPregnancy"
                name="lengthOfPregnancy"
                data-cy="lengthOfPregnancy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.dandc')}
                id="obstetric-event-dandc"
                name="dandc"
                data-cy="dandc"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.childGender')}
                id="obstetric-event-childGender"
                name="childGender"
                data-cy="childGender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.childWeight')}
                id="obstetric-event-childWeight"
                name="childWeight"
                data-cy="childWeight"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.complications')}
                id="obstetric-event-complications"
                name="complications"
                data-cy="complications"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.deliveryType')}
                id="obstetric-event-deliveryType"
                name="deliveryType"
                data-cy="deliveryType"
                type="select"
              >
                {deliveryTypeValues.map(deliveryType => (
                  <option value={deliveryType} key={deliveryType}>
                    {translate(`tinyMedicRestApp.DeliveryType.${deliveryType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.eventType')}
                id="obstetric-event-eventType"
                name="eventType"
                data-cy="eventType"
                type="select"
              >
                {pregnancyResultValues.map(pregnancyResult => (
                  <option value={pregnancyResult} key={pregnancyResult}>
                    {translate(`tinyMedicRestApp.PregnancyResult.${pregnancyResult}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.labourStartDate')}
                id="obstetric-event-labourStartDate"
                name="labourStartDate"
                data-cy="labourStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.lenghtOfLabor')}
                id="obstetric-event-lenghtOfLabor"
                name="lenghtOfLabor"
                data-cy="lenghtOfLabor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.active')}
                id="obstetric-event-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.draft')}
                id="obstetric-event-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.cursor')}
                id="obstetric-event-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.lastUpdated')}
                id="obstetric-event-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.microSec')}
                id="obstetric-event-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.timestampEntry')}
                id="obstetric-event-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.expose')}
                id="obstetric-event-expose"
                name="expose"
                data-cy="expose"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.obstetricEvent.consentTaken')}
                id="obstetric-event-consentTaken"
                name="consentTaken"
                data-cy="consentTaken"
                check
                type="checkbox"
              />
              <ValidatedField
                id="obstetric-event-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.obstetricEvent.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="obstetric-event-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.obstetricEvent.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/obstetric-event" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ObstetricEventUpdate;
